function redirect(url)
{
    // If we redirect to the same URL, we'll use the `reload()` method,
    // since `window.location.href = window.location.href` won't work in Chrome.
    if (window.location.href.endsWith(url)) {
        window.location.reload();
    } else {
        window.location.href = url;
    }
}

export default redirect;
